import React, { createContext, useCallback, useContext, useState } from 'react'
import ApiService from '../../service/ApiService';

export const ProductContext = createContext()

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([])

  const getVendorProducts = useCallback(async (vendorId) => {
    const res = await ApiService(`/products_list/${vendorId}`, {}, 'get')
    const vendorProducts = res?.data || []
    setProducts(prev => {
      const map = new Map(prev.map(p => [p.id, p]))
      vendorProducts.forEach(p => map.set(p.id, p))
      return Array.from(map.values())
    })
    return vendorProducts
  }, [])

  const functions = {
    getVendorProducts
  }

  return (
    <ProductContext.Provider value={[products, functions]}>
      {children}
    </ProductContext.Provider>
  )
}

export const useProduct = () => {
  const productManager = useContext(ProductContext)
  return productManager || [[], {}]
}
